// extracted by mini-css-extract-plugin
export var dropdownContainer = "_kv-0";
export var leftAlign = "_kv-4";
export var listItem = "_kv-2";
export var listItemWrapper = "_kv-1";
export var operationText = "_kv-3";